import type { CandidateDocument, DocumentReview, DocumentVersion } from '../types/platform';

export const candidateDocuments: CandidateDocument[] = [
  {
    id: 'doc-1',
    candidateProfileId: 'cand-1',
    category: 'executive_resume',
    reviewStatus: 'accepted_for_current_stage',
    currentVersionId: 'ver-1-2',
    createdAt: '2026-06-04T10:00:00Z',
    updatedAt: '2026-08-18T09:30:00Z',
  },
  {
    id: 'doc-2',
    candidateProfileId: 'cand-1',
    category: 'executive_biography',
    reviewStatus: 'accepted_for_current_stage',
    currentVersionId: 'ver-2-1',
    requestedByRecruiterId: 'rec-1',
    requestedAt: '2026-08-22T12:00:00Z',
    createdAt: '2026-08-23T08:15:00Z',
    updatedAt: '2026-08-24T14:00:00Z',
  },
  {
    id: 'doc-3',
    candidateProfileId: 'cand-1',
    category: 'professional_references',
    reviewStatus: 'submitted',
    currentVersionId: 'ver-3-1',
    requestedByRecruiterId: 'rec-1',
    requestedAt: '2026-08-28T11:00:00Z',
    createdAt: '2026-08-29T19:20:00Z',
    updatedAt: '2026-08-29T19:20:00Z',
  },
  {
    id: 'doc-4',
    candidateProfileId: 'cand-1',
    category: 'leadership_philosophy_statement',
    reviewStatus: 'not_required',
    currentVersionId: '',
    createdAt: '2026-06-04T10:00:00Z',
    updatedAt: '2026-08-20T09:00:00Z',
  },
  {
    id: 'doc-5',
    candidateProfileId: 'cand-2',
    category: 'executive_resume',
    reviewStatus: 'updated_version_received',
    currentVersionId: 'ver-5-2',
    createdAt: '2026-08-24T15:00:00Z',
    updatedAt: '2026-08-29T21:10:00Z',
  },
  {
    id: 'doc-6',
    candidateProfileId: 'cand-3',
    category: 'board_resume',
    reviewStatus: 'under_review',
    currentVersionId: 'ver-6-1',
    createdAt: '2026-08-29T08:40:00Z',
    updatedAt: '2026-08-31T08:35:00Z',
  },
  {
    id: 'doc-7',
    candidateProfileId: 'cand-4',
    category: 'executive_resume',
    reviewStatus: 'submitted',
    currentVersionId: 'ver-7-1',
    createdAt: '2026-08-31T19:55:00Z',
    updatedAt: '2026-08-31T19:55:00Z',
  },
  {
    id: 'doc-8',
    candidateProfileId: 'cand-5',
    category: 'executive_resume',
    reviewStatus: 'accepted_for_current_stage',
    currentVersionId: 'ver-8-1',
    createdAt: '2026-08-14T11:00:00Z',
    updatedAt: '2026-08-18T14:35:00Z',
  },
  {
    id: 'doc-9',
    candidateProfileId: 'cand-6',
    category: 'executive_resume',
    reviewStatus: 'revision_requested',
    currentVersionId: 'ver-9-1',
    createdAt: '2026-08-21T09:45:00Z',
    updatedAt: '2026-08-24T10:30:00Z',
  },
  {
    id: 'doc-10',
    candidateProfileId: 'cand-3',
    category: 'board_value_proposition',
    reviewStatus: 'archived',
    currentVersionId: 'ver-10-1',
    createdAt: '2026-05-22T12:00:00Z',
    updatedAt: '2026-07-30T09:00:00Z',
  },
];

/** Append-only. A new upload creates a version; it never replaces one. */
export const documentVersions: DocumentVersion[] = [
  {
    id: 'ver-1-1',
    documentId: 'doc-1',
    versionNumber: 1,
    fileName: 'Whitfield-Executive-Resume.pdf',
    fileType: 'pdf',
    fileSizeBytes: 218_450,
    uploadedAt: '2026-06-04T10:00:00Z',
    uploadedByUserId: 'user-cand-1',
    scanStatus: 'clean',
    storageKey: 'private/cand-1/doc-1/v1',
  },
  {
    id: 'ver-1-2',
    documentId: 'doc-1',
    versionNumber: 2,
    fileName: 'Whitfield-Executive-Resume-Aug2026.pdf',
    fileType: 'pdf',
    fileSizeBytes: 231_004,
    uploadedAt: '2026-08-18T09:30:00Z',
    uploadedByUserId: 'user-cand-1',
    scanStatus: 'clean',
    storageKey: 'private/cand-1/doc-1/v2',
  },
  {
    id: 'ver-2-1',
    documentId: 'doc-2',
    versionNumber: 1,
    fileName: 'Whitfield-Executive-Biography.docx',
    fileType: 'docx',
    fileSizeBytes: 42_118,
    uploadedAt: '2026-08-23T08:15:00Z',
    uploadedByUserId: 'user-cand-1',
    scanStatus: 'clean',
    storageKey: 'private/cand-1/doc-2/v1',
  },
  {
    id: 'ver-3-1',
    documentId: 'doc-3',
    versionNumber: 1,
    fileName: 'Whitfield-References.pdf',
    fileType: 'pdf',
    fileSizeBytes: 88_920,
    uploadedAt: '2026-08-29T19:20:00Z',
    uploadedByUserId: 'user-cand-1',
    scanStatus: 'clean',
    storageKey: 'private/cand-1/doc-3/v1',
  },
  {
    id: 'ver-5-1',
    documentId: 'doc-5',
    versionNumber: 1,
    fileName: 'Achebe-Resume.docx',
    fileType: 'docx',
    fileSizeBytes: 61_204,
    uploadedAt: '2026-08-24T15:00:00Z',
    uploadedByUserId: 'user-cand-2',
    scanStatus: 'clean',
    storageKey: 'private/cand-2/doc-5/v1',
  },
  {
    id: 'ver-5-2',
    documentId: 'doc-5',
    versionNumber: 2,
    fileName: 'Achebe-Executive-Resume-v2.pdf',
    fileType: 'pdf',
    fileSizeBytes: 197_640,
    uploadedAt: '2026-08-29T21:10:00Z',
    uploadedByUserId: 'user-cand-2',
    scanStatus: 'clean',
    storageKey: 'private/cand-2/doc-5/v2',
  },
  {
    id: 'ver-6-1',
    documentId: 'doc-6',
    versionNumber: 1,
    fileName: 'Raghunathan-Board-Resume.pdf',
    fileType: 'pdf',
    fileSizeBytes: 165_002,
    uploadedAt: '2026-08-29T08:40:00Z',
    uploadedByUserId: 'user-cand-3',
    scanStatus: 'clean',
    storageKey: 'private/cand-3/doc-6/v1',
  },
  {
    id: 'ver-7-1',
    documentId: 'doc-7',
    versionNumber: 1,
    fileName: 'Lindqvist-Executive-Resume.pdf',
    fileType: 'pdf',
    fileSizeBytes: 204_881,
    uploadedAt: '2026-08-31T19:55:00Z',
    uploadedByUserId: 'user-cand-4',
    scanStatus: 'clean',
    storageKey: 'private/cand-4/doc-7/v1',
  },
  {
    id: 'ver-8-1',
    documentId: 'doc-8',
    versionNumber: 1,
    fileName: 'Ferreira-Executive-Resume.pdf',
    fileType: 'pdf',
    fileSizeBytes: 189_330,
    uploadedAt: '2026-08-14T11:00:00Z',
    uploadedByUserId: 'user-cand-5',
    scanStatus: 'clean',
    storageKey: 'private/cand-5/doc-8/v1',
  },
  {
    id: 'ver-9-1',
    documentId: 'doc-9',
    versionNumber: 1,
    fileName: 'Baptiste-Resume.doc',
    fileType: 'doc',
    fileSizeBytes: 74_502,
    uploadedAt: '2026-08-21T09:45:00Z',
    uploadedByUserId: 'user-cand-6',
    scanStatus: 'clean',
    storageKey: 'private/cand-6/doc-9/v1',
  },
  {
    id: 'ver-10-1',
    documentId: 'doc-10',
    versionNumber: 1,
    fileName: 'Raghunathan-BVP-2026.pdf',
    fileType: 'pdf',
    fileSizeBytes: 51_770,
    uploadedAt: '2026-05-22T12:00:00Z',
    uploadedByUserId: 'user-cand-3',
    scanStatus: 'clean',
    storageKey: 'private/cand-3/doc-10/v1',
  },
];

/**
 * Reviews are separate records from documents, which is what keeps candidate
 * files immutable to staff. Candidate-visible feedback is structured; internal
 * notes are never rendered in a candidate view.
 */
export const documentReviews: DocumentReview[] = [
  {
    id: 'rev-1',
    documentId: 'doc-1',
    documentVersionId: 'ver-1-2',
    reviewerUserId: 'user-rec-1',
    reviewerName: 'Claudia B. Nwosu',
    outcome: 'accepted_for_current_stage',
    candidateVisibleFeedback: [
      {
        issueCategory: 'evidence_of_impact',
        observation:
          'The standardization programme is described with specific measures at three of four sites, which is exactly the level of evidence a client committee looks for.',
        suggestedAction:
          'No change required for this stage. If the client asks for a second document, add the ambulatory expansion outcomes in the same form.',
      },
    ],
    internalNote:
      'Strongest résumé in the longlist on evidence quality. Ambulatory experience genuinely thinner than the spec asks — flag to client rather than paper over.',
    reviewedAt: '2026-08-18T14:00:00Z',
  },
  {
    id: 'rev-2',
    documentId: 'doc-5',
    documentVersionId: 'ver-5-1',
    reviewerUserId: 'user-rec-1',
    reviewerName: 'Claudia B. Nwosu',
    outcome: 'revision_requested',
    candidateVisibleFeedback: [
      {
        issueCategory: 'evidence_of_impact',
        observation:
          'The reporting modernization is described as a responsibility rather than an outcome. The close timeline moved from an unstated starting point to five days, but the document does not say what it was before.',
        suggestedAction:
          'State the starting position and the end position for each of the three main changes, with the timeframe. One line each is sufficient.',
      },
      {
        issueCategory: 'clarity_of_scope',
        observation:
          'It is not clear from the document whether you owned the eleven-entity consolidation or contributed to it.',
        suggestedAction:
          'Add your decision rights explicitly — what you approved, what you recommended, and who you reported to on the programme.',
      },
      {
        issueCategory: 'structure_and_length',
        observation: 'At six pages the document buries the two most relevant achievements on page four.',
        suggestedAction:
          'Reduce to three pages and move the modernization programme and the audit remediation into the first half page.',
      },
    ],
    internalNote:
      'Genuine transformation experience underneath a poorly structured document. Worth the revision round. Do not confuse the document quality with the candidate quality in the client submission.',
    reviewedAt: '2026-08-27T13:15:00Z',
  },
  {
    id: 'rev-3',
    documentId: 'doc-5',
    documentVersionId: 'ver-5-2',
    reviewerUserId: 'user-rec-1',
    reviewerName: 'Claudia B. Nwosu',
    outcome: 'accepted_for_current_stage',
    candidateVisibleFeedback: [
      {
        issueCategory: 'completeness',
        observation:
          'All three points from the previous review have been addressed, and the decision rights are now explicit.',
        suggestedAction: 'No further change required for this stage.',
      },
    ],
    internalNote: 'Responded quickly and accurately to structured feedback. Positive signal on coachability.',
    reviewedAt: '2026-08-30T10:00:00Z',
  },
  {
    id: 'rev-4',
    documentId: 'doc-9',
    documentVersionId: 'ver-9-1',
    reviewerUserId: 'user-rec-1',
    reviewerName: 'Claudia B. Nwosu',
    outcome: 'revision_requested',
    candidateVisibleFeedback: [
      {
        issueCategory: 'positioning',
        observation:
          'The document positions you for energy development leadership, which is well evidenced. It does not address the defense business-unit scope you applied for, and a client reading it would not see the connection you described in your screening answer.',
        suggestedAction:
          'If you wish to pursue defense business-unit roles, add a short positioning paragraph making the profit-and-loss and government-customer parallels explicit. Alternatively, we would be glad to discuss energy mandates where your evidence is directly on point.',
      },
    ],
    internalNote:
      'Strong energy development candidate; not credible for the defense capture requirement. Do not advance on this mandate. Redirect to mandate-8, where the fit is genuine.',
    reviewedAt: '2026-08-24T10:25:00Z',
  },
  {
    id: 'rev-5',
    documentId: 'doc-6',
    documentVersionId: 'ver-6-1',
    reviewerUserId: 'user-rec-2',
    reviewerName: 'Idris F. Kaplan',
    outcome: 'under_review',
    candidateVisibleFeedback: [],
    internalNote: 'Independence review outstanding before I complete the document review. Adjacent-market directorship to assess.',
    reviewedAt: '2026-08-31T08:35:00Z',
  },
];
